import { InstagramDashboard } from "components/InstagramData";
import SideMenu from "components/SideMenu";
import SectionHeading from "components/text/SectionHeading";
import { useAuth } from "providers/auth.provider";
import { useState } from "react";

export const GoogleMetrics = () => {
  const { user } = useAuth();

  const [connected, setConnected] = useState<boolean | null>(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  if (!user) {
    return <div>There was an error. Please contact support</div>;
  }

  if (loading) return <p>Loading...</p>;
  if (error) return <p className="text-red-500">{error}</p>;

  if (!connected)
    return (
      <div className="grid min-h-screen grid-cols-1 md:grid-cols-[240px_1fr]">
        <SideMenu />
        <main className="p-6">
          <div className="mb-6 flex items-center justify-between gap-3">
            <h1 className="text-2xl font-semibold tracking-tight">Google</h1>
          </div>
          <div className="grid gap-4 mb-6">
            <SectionHeading
              title="Google Metrics"
              subtitle="Dive into your Google Analytics and Google Search Console data. First, get connected."
            />
            {!connected && (
              <button
                className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
                onClick={() => {}}
              >
                Connect Google Analytics
              </button>
            )}
          </div>
        </main>
      </div>
    );

  return (
    <div className="grid min-h-screen grid-cols-1 md:grid-cols-[240px_1fr]">
      <SideMenu />
      <main className="p-6">
        <div className="mb-6 flex items-center justify-between gap-3">
          <h1 className="text-2xl font-semibold tracking-tight">Google</h1>
        </div>
        <div className="grid gap-4 mb-6">
          <SectionHeading
            title="Google Analytics"
            subtitle="Dive into your instagram metrics and audience behaviour"
          />
        </div>
      </main>
    </div>
  );
};
